export function throttle(func: Function, timeFrame: number) {
    let lastTime = 0;
    return function () {
        const now = new Date().valueOf();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}
